import { Route, Routes } from 'react-router-dom';
import { PATH } from '../constants';
import Login from '../routes/auth/login';
import SignUp from '../routes/auth/sign-up';
import Bookmarks from '../routes/bookmarks';
import Channel from '../routes/channel';
import Channels from '../routes/channels';
import Discover from '../routes/discover';
import Events from '../routes/events';
import Feeds from '../routes/feeds';
import Notifications from '../routes/notifications';
import Profile from '../routes/profile';
import Categories from '../routes/releases/categories';
import Releases from '../routes/releases/releases';
import Settings from '../routes/settings';
import Subscriptions from '../routes/subscriptions';

export default function App() {
  return (
    <Routes>
      <Route path={PATH.HOME}>
        <Route path="" element={<Feeds />} />
        <Route path=":profileId" element={<Profile />} />
      </Route>
      <Route path={PATH.DISCOVER} element={<Discover />}>
        <Route path={'?/tab=artists'} element={<Discover />} />
      </Route>
      <Route path={PATH.CHANNELS}>
        <Route path=":channelId" element={<Channel />} />
        <Route path="" element={<Channels />} />
      </Route>
      <Route path={PATH.BOOKMARKS} element={<Bookmarks />} />
      <Route path={PATH.EVENTS} element={<Events />} />
      <Route path={PATH.RELEASES}>
        <Route path={':genre'} element={<Releases />} />
        <Route path="" element={<Categories />} />
      </Route>
      <Route path={PATH.SUBSCRIPTIONS} element={<Subscriptions />} />
      <Route path={PATH.NOTIFICATIONS} element={<Notifications />} />
      <Route path={PATH.SETTINGS} element={<Settings />}>
        <Route path={'?tab=account'} element={<Settings />} />
      </Route>
      <Route path={PATH.AUTH}>
        <Route path={PATH.LOGIN} element={<Login />} />
        <Route path={PATH.SIGN_UP} element={<SignUp />} />
      </Route>
    </Routes>
  );
}
